import Page from 'flarum/common/components/Page';

export default class TermsPage extends Page {
    oninit(){
        this.content = (
            <>
                {m.trust(app.forum.attribute('info-pages.terms-content'))}
            </>
        )
    }


    view() {
        return this.content;
    }
}
